var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonitoringReporting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.999,
    height: 29.983,
    viewBox: "0 0 29.999 29.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7667"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3821",
    d: "M29.998 6.26v22.289a1.591 1.591 0 0 1-.546 1.029 1.7 1.7 0 0 1-1.186.405q-4.124-.005-8.248 0H8.875a1.769 1.769 0 0 1-1.9-1.9q-.005-5.484 0-10.967v-.176c0-.473 0-.469-.466-.474a6.428 6.428 0 0 1-4.717-2 5.9 5.9 0 0 1-1.728-3.5 6.7 6.7 0 0 1 .409-3.557 6.446 6.446 0 0 1 4.785-3.861 5.342 5.342 0 0 1 1.395-.124c.24.013.33-.089.325-.327-.009-.448-.014-.9 0-1.345A1.867 1.867 0 0 1 7.81.219a1.983 1.983 0 0 1 .714-.22h15.153a1.063 1.063 0 0 1 .568.321q2.711 2.718 5.429 5.429a1.238 1.238 0 0 1 .324.511z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3822",
    d: "M6506.6 2426.076h-9.478c-.636 0-.819-.182-.819-.818q0-5.747-.007-11.495a.392.392 0 0 1 .317-.445 6.214 6.214 0 0 0 4.3-5.327 6.346 6.346 0 0 0-4.39-6.868c-.163-.055-.234-.112-.229-.3.015-.555 0-1.111.006-1.667a.613.613 0 0 1 .707-.694q6.9 0 13.807-.006c.2 0 .234.063.233.244-.007 1.609 0 3.218 0 4.826 0 .594.192.785.793.785 1.6 0 3.2.006 4.8-.006.225 0 .265.062.265.273q-.009 10.369 0 20.737c0 .555-.2.758-.762.758z",
    transform: "translate(-6488.071 -2397.293)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3823",
    d: "M6381.493 2462.024v2.4c0 .519.21.728.73.729 1.607 0 3.215.007 4.823-.006.248 0 .26.08.227.279a5.262 5.262 0 1 1-6.052-6.053c.2-.032.285-.017.278.23-.018.803-.006 1.612-.006 2.421z",
    transform: "translate(-6375.6 -2454.62)",
    style: {
      fill: "#f84525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3824",
    d: "M6476.378 2461.634c0-.7.008-1.4-.006-2.105 0-.2.062-.216.231-.195a5.324 5.324 0 0 1 4.394 4.409c.019.16 0 .215-.183.214q-2.121-.012-4.241 0c-.178 0-.2-.064-.2-.218.008-.701.005-1.403.005-2.105z",
    transform: "translate(-6469.314 -2454.592)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3825",
    d: "M6771.553 2417.6h-3.611c-.084 0-.175.024-.175-.12v-3.664z",
    transform: "translate(-6743.621 -2411.747)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3826",
    d: "M6532.805 2643.979a1.7 1.7 0 0 1 1.507.992 1.645 1.645 0 0 1-.165 1.792 1.665 1.665 0 0 1-1.718.685.317.317 0 0 0-.331.106q-1.89 2.036-3.791 4.064c-.117.124-.1.2-.034.346a1.658 1.658 0 0 1-.207 1.886 1.635 1.635 0 0 1-1.777.593 1.683 1.683 0 0 1-1.3-1.389 1.5 1.5 0 0 1 .084-.888.331.331 0 0 0-.059-.392c-.522-.63-1.033-1.269-1.541-1.912a.276.276 0 0 0-.364-.12 1.448 1.448 0 0 1-1.031-.016.274.274 0 0 0-.351.091q-.921 1.02-1.863 2.021a.279.279 0 0 0-.055.334 1.74 1.74 0 0 1-2.229 2.22 1.677 1.677 0 0 1-1.147-1.421 1.741 1.741 0 0 1 2.231-1.889.337.337 0 0 0 .421-.109c.6-.667 1.209-1.325 1.822-1.98a.277.277 0 0 0 .069-.331 1.74 1.74 0 0 1 2.239-2.228 1.693 1.693 0 0 1 1.135 1.432 1.387 1.387 0 0 1-.1.773.371.371 0 0 0 .079.441c.51.615 1.01 1.239 1.5 1.865.109.137.2.207.386.131a1.067 1.067 0 0 1 .69-.061.474.474 0 0 0 .543-.2q1.807-1.955 3.63-3.894a.322.322 0 0 0 .074-.439 1.756 1.756 0 0 1 1.653-2.503z",
    transform: "translate(-6507.014 -2628.416)",
    style: {
      fill: "#f84525"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3827",
    d: "M21.453 10.53h-4.325c-.513 0-.815-.364-.659-.779a.584.584 0 0 1 .593-.388H25.772c.441.005.722.24.714.6s-.28.573-.707.573l-4.326-.006z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3828",
    d: "M21.427 12.871h-4.383a.584.584 0 1 1-.014-1.167h8.645c.522 0 .811.214.805.593s-.288.577-.791.577z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3829",
    d: "M18.109 4.681c-1 0-2.006.005-3.009 0a.585.585 0 0 1-.58-.867.669.669 0 0 1 .651-.3h5.959a.61.61 0 0 1 .674.576c.005.348-.27.591-.688.592-1.002.001-2.005-.001-3.007-.001z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3830",
    d: "M18.124 7.02h-2.921a1.309 1.309 0 0 1-.346-.036.549.549 0 0 1-.416-.537.559.559 0 0 1 .424-.56 1.38 1.38 0 0 1 .346-.034h5.813a1.477 1.477 0 0 1 .319.023.572.572 0 0 1-.008 1.123 1.565 1.565 0 0 1-.319.021q-1.445.002-2.892 0z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3831",
    d: "M6597.41 2538.85a.582.582 0 1 1-.571-.585.6.6 0 0 1 .571.585z",
    transform: "translate(-6582.159 -2528.901)",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3832",
    d: "M6597.414 2578.748a.582.582 0 1 1-.579-.577.6.6 0 0 1 .579.577z",
    transform: "translate(-6582.162 -2566.466)",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3833",
    d: "M6400.626 2542.939a4.11 4.11 0 0 1-3.906-3.941c-.012-.437.217-.726.576-.73s.571.26.592.691a2.961 2.961 0 0 0 2.792 2.811c.454.022.722.248.713.6s-.303.586-.767.569z",
    transform: "translate(-6394.332 -2528.904)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3834",
    d: "M6612.8 2705.029a.582.582 0 1 1 .582-.574.6.6 0 0 1-.582.574z",
    transform: "translate(-6597.191 -2684.791)",
    style: {
      fill: "#fdfdfd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3835",
    d: "M6537.553 2784.267a.582.582 0 1 1-.561-.595.6.6 0 0 1 .561.595z",
    transform: "translate(-6525.811 -2759.916)",
    style: {
      fill: "#fdfdfd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3836",
    d: "M6682.642 2784.836a.581.581 0 1 1 .571-.584.6.6 0 0 1-.571.584z",
    transform: "translate(-6662.93 -2759.918)",
    style: {
      fill: "#fdfdfd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3837",
    d: "M6785.423 2663.958a.581.581 0 1 1-.6.551.6.6 0 0 1 .6-.551z",
    transform: "translate(-6759.673 -2647.223)",
    style: {
      fill: "#fefefe"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringReporting);
export default __webpack_public_path__ + "static/media/Monitoring_&_Reporting.a68c550b90eaffa283454c2f43f527f4.svg";
export { ForwardRef as ReactComponent };